import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    // Only lowercase the path segment, not the query string,
    // so that case-sensitive tokens in query parameters are preserved.
    const questionMarkIndex = url.indexOf('?');
    if (questionMarkIndex > -1) {
      return super.parse(url.slice(0, questionMarkIndex).toLowerCase() + url.slice(questionMarkIndex));
    }
    return super.parse(url.toLowerCase());
  }
}
